import React from 'react';
import { bool, object } from 'prop-types';

import CSS from './styles.css';

import Spinner from 'Shared/Spinner';
import Notifications from 'Shared/Notifications';
import Bookmark from 'Components/Bookmark';
// import RightSidePanel from 'Components/RightSidePanel';
import Annotation from 'Components/Annotation';
// import FAB from 'Components/FAB';
// import Navigation from 'Components/Navigation';
import VSReader from 'Components/VSReader';


const EbookViews = ({ createPageViewerFail, isLoading, isOpen, styles }) => {
  return (
    <div className={ CSS['container'] } style={ styles } tabIndex="0">

      { isLoading
        ? <Spinner />
        : createPageViewerFail
          ? <Notifications />
          : null
      }

      { /*!isLoading && !createPageViewerFail
        ? <Bookmark />
        : null
      */}

      <VSReader />

      { isOpen
        ? <Annotation />
        : null
      }

      {/*<RightSidePanel />*/}

      {/*<Navigation />*/}

      {/*<FAB />*/}

    </div>
  );
};

EbookViews.propTypes = {
  isOpen: bool,
  styles: object
};


export default EbookViews;
